import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";

// About and Contact
import AboutPage from "@/pages/about/page";
import ContactPage from "@/pages/contact/page";

// Coolnet pages
import CoolnetLandingPage from "@/pages/coolnet/CoolnetLandingPage";
import WhyVentracorePage from "@/pages/coolnet/WhyVentracorePage";
import PrecisionACPage from "@/pages/coolnet/PrecisionACPage";
import LiquidCoolingPage from "@/pages/coolnet/LiquidCoolingPage";
import UPSPage from "@/pages/coolnet/UPSPage";
import IntegratedPage from "@/pages/coolnet/IntegratedPage";

// Services pages
import ServicesOverviewPage from "@/pages/services/ServicesOverviewPage";
import HvacPage from "@/pages/services/HvacPage";
import CongelacionPage from "@/pages/services/CongelacionPage";
import EquipoEspecializadoPage from "@/pages/services/EquipoEspecializadoPage";
import ElectricosPage from "@/pages/services/ElectricosPage";
import EnergiaUPSPage from "@/pages/services/EnergiaUPSPage";
import InstalacionPage from "@/pages/services/InstalacionPage";
import ServiciosGeneralesPage from "@/pages/services/ServiciosGeneralesPage";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/nosotros",
    element: <AboutPage />,
  },
  {
    path: "/contacto",
    element: <ContactPage />,
  },
  {
    path: "/servicios",
    element: <ServicesOverviewPage />,
  },
  {
    path: "/hvac",
    element: <HvacPage />,
  },
  {
    path: "/congelacion",
    element: <CongelacionPage />,
  },
  {
    path: "/equipo-especializado",
    element: <EquipoEspecializadoPage />,
  },
  {
    path: "/electricos-especializados",
    element: <ElectricosPage />,
  },
  {
    path: "/energia-ups",
    element: <EnergiaUPSPage />,
  },
  {
    path: "/instalacion-y-mantenimiento",
    element: <InstalacionPage />,
  },
  {
    path: "/servicios-generales",
    element: <ServiciosGeneralesPage />,
  },
  {
    path: "/coolnet",
    element: <CoolnetLandingPage />,
  },
  {
    path: "/coolnet/por-que-ventracore",
    element: <WhyVentracorePage />,
  },
  {
    path: "/coolnet/aire-acondicionado-precision",
    element: <PrecisionACPage />,
  },
  {
    path: "/coolnet/refrigeracion-liquida",
    element: <LiquidCoolingPage />,
  },
  {
    path: "/coolnet/sistema-ups",
    element: <UPSPage />,
  },
  {
    path: "/coolnet/solucion-integrada",
    element: <IntegratedPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
